import i18n from '@/utils/i18n';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { StyleSheet, Text } from 'react-native';
import { useState } from 'react';

export const ItemLegalDisclaimer: React.FC = () => {
  const [showDisclaimerActionSheet, setShowDisclaimerActionSheet] =
    useState(false);

  return (
    <>
      <Text
        onPress={() => setShowDisclaimerActionSheet(true)}
        style={[TYPOGRAPHY.small, FONTS.primaryBold, styles.linkText]}
      >
        {i18n.t('item_legal_disclaimer')}
      </Text>
      <BaseActionSheet
        isVisible={showDisclaimerActionSheet}
        onClose={() => setShowDisclaimerActionSheet(false)}
        showCloseButton={false}
      >
        <Text style={[TYPOGRAPHY.cardHeaderText, styles.title]}>
          {i18n.t('item_legal_disclaimer')}
        </Text>
        <Text style={TYPOGRAPHY.medium}>
          {i18n.t('item_legal_disclaimer_info')}
        </Text>
      </BaseActionSheet>
    </>
  );
};

const styles = StyleSheet.create({
  linkText: {
    paddingVertical: 16,
    textAlign: 'center',
    textDecorationLine: 'underline',
  },
  title: {
    marginBottom: 16,
    textAlign: 'left',
  },
});
